import { useBootstrap } from "./useBootstrap";
import UserDataLoader from "../../components/UserDataLoader";

export function BootstrapGate({ children }) {
  const { data: user, isLoading, isError, refetch } = useBootstrap();

  if (isLoading) {
    return <UserDataLoader />;
  }

  if (isError || !user) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#F4F4F3]">
        <div className="flex flex-col items-center gap-4 max-w-sm text-center px-6">
          <span className="text-[16px] font-semibold text-gray-700">
            Unable to load your profile
          </span>
          <span className="text-[15px] text-gray-500">
            Check your connection and try again.
          </span>
          <button
            onClick={() => refetch()}
            className="bg-[#256AA6] text-white font-bold text-[15px] py-2 px-5 rounded"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return children;
}
